export class NotificacaoUsuario {
  constructor({
    id = null,
    assunto = null,
    descricao = null,
    dataNotificacao = null,
    lida = false,
  }) {
    this.id = id;
    this.assunto = assunto;
    this.descricao = descricao;
    this.dataNotificacao = dataNotificacao;
    this.lida = lida;
  }

  static Build() {
    return new NotificacaoUsuario({
      id: null,
      assunto: null,
      descricao: null,
      dataNotificacao: null,
      lida: false,
    });
  }

  format() {
    return this;
  }
}